import isNil from "lodash/fp/isNil";
import forOwn from "lodash/fp/forOwn";
class Controller {
  constructor($state, $mdDialog, captainName, forced) {
    "ngInject";

    this.forced = forced;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.captainName = captainName;
  }

  close() {
    this.$mdDialog.cancel();
  }

  navigateToCaptains() {
    this.close();
    this.$state.transitionTo("captains");
  }

  confirm() {
    const dialogResults = {};
    const forOwnWithKeys = forOwn.convert({ cap: false });
    forOwnWithKeys((plan, key) => {
      if (!isNil(plan)) {
        dialogResults[key] = plan._id;
        if (!isNil(plan.dependents)) {
          Object.assign(dialogResults, { ...plan.dependents });
        }
      }
    })(this.captainPlans);
    this.$mdDialog.hide({
      ...dialogResults,
    });
  }

  clearInput(ctrl, model) {
    ctrl[model] = null;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/captainPlan/assignPlanDialog/assignPlanDialog.controller.js